// Español (México). Keys must match en-US.js (checked by i18n.test.js).
const esMX = {
  app: {
    name: 'SmartLanded',
    descriptor: 'Calculadora de landed cost',
    language: 'Idioma'
  },
  common: {
    loading: 'Cargando…',
    noData: 'Sin datos.',
    save: 'Guardar',
    saving: 'Guardando…',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    open: 'Abrir',
    add: 'Agregar',
    remove: 'Quitar',
    back: 'Regresar',
    yes: 'Sí',
    no: 'No',
    default: 'Predeterminado',
    all: 'Todos',
    total: 'Total',
    actions: 'Acciones',
    status: 'Estado',
    created: 'Creado',
    rowsPerPage: 'Filas por página',
    totalCount: '{count} en total',
    prev: 'Anterior',
    next: 'Siguiente',
    pageOf: 'Página {page} de {pages}',
    actionFailed: 'No se pudo completar la acción',
    none: '—'
  },
  nav: {
    dashboard: 'Tablero',
    shipments: 'Embarques',
    users: 'Usuarios',
    tariffs: 'Tarifas',
    help: 'Ayuda',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    signOut: 'Cerrar sesión'
  },
  roles: {
    system_admin: 'Administrador del sistema',
    client: 'Cliente'
  },
  login: {
    subtitle: 'Inicia sesión para continuar',
    email: 'Correo',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    submitting: 'Iniciando sesión…',
    failed: 'Credenciales inválidas',
    noAccount: '¿No tienes cuenta?',
    startTrial: 'Prueba gratis',
    forgot: '¿Olvidaste tu contraseña?'
  },
  forgot: {
    subtitle: 'Escribe tu correo y te enviaremos un código para crear una contraseña nueva.',
    send: 'Enviar código',
    sending: 'Enviando…',
    sendFailed: 'No se pudo enviar el código',
    sentTo: 'Si hay una cuenta con ese correo, le enviamos un código a',
    noAccountHint: '¿No es tu correo?',
    changeEmail: 'Cambiarlo',
    newPassword: 'Contraseña nueva',
    submit: 'Guardar y entrar',
    done: 'Listo. Tu contraseña se actualizó.',
    resetFailed: 'No se pudo cambiar la contraseña',
    backToLogin: 'Volver a iniciar sesión'
  },
  signup: {
    subtitle: 'Crea tu cuenta y calcula tus primeros embarques gratis.',
    perkShipments: '3 embarques gratis',
    perkCard: 'Sin tarjeta',
    perkSetup: 'Listo en 2 minutos',
    firstName: 'Nombre',
    lastName: 'Apellido',
    company: 'Empresa',
    email: 'Correo de trabajo',
    emailHint: 'Te enviaremos un código para verificarlo.',
    password: 'Contraseña',
    passwordHint: 'Mínimo {min} caracteres.',
    passwordWeak: 'Muy corta',
    passwordOk: 'Aceptable',
    passwordStrong: 'Segura',
    acceptPrefix: 'Acepto los',
    terms: 'Términos y Condiciones',
    and: 'y el',
    privacy: 'Aviso de Privacidad',
    submit: 'Crear cuenta',
    submitting: 'Creando cuenta…',
    failed: 'No se pudo crear la cuenta',
    emailTaken: 'Ya existe una cuenta con este correo. Inicia sesión.',
    haveAccount: '¿Ya tienes cuenta?',
    signIn: 'Inicia sesión'
  },
  verify: {
    sentTo: 'Enviamos un código de 6 dígitos a',
    enterCode: 'Escribe el código',
    digit: 'Dígito {n}',
    expires: 'El código vence en 15 minutos.',
    submit: 'Verificar y entrar',
    verifying: 'Verificando…',
    failed: 'No se pudo verificar el código',
    welcome: '¡Listo! Tu cuenta está activa.',
    alreadyVerified: 'Tu correo ya estaba verificado. Inicia sesión.',
    noCode: '¿No te llegó?',
    resend: 'Reenviar código',
    resendIn: 'Reenviar en {seconds} s',
    resent: 'Te enviamos un código nuevo',
    resentOnLogin: 'Tu correo no está verificado; te enviamos un código nuevo',
    resendFailed: 'No se pudo reenviar el código',
    wrongEmail: '¿Correo equivocado?',
    signupAgain: 'Regístrate de nuevo'
  },
  trial: {
    label: 'Prueba gratis',
    remaining_one: 'Te queda {count} de {limit} embarques gratis',
    remaining_other: 'Te quedan {count} de {limit} embarques gratis',
    body: 'Cada embarque incluye la lectura de sus documentos y el costo por SKU.',
    used: '{used} de {limit} usados',
    reachedTitle: 'Usaste tus {limit} embarques gratis',
    reachedBody: 'Tus embarques y resultados siguen disponibles. Escríbenos para seguir calculando.',
    dialogBody: 'Para crear más embarques necesitas un plan. Escríbenos y te ayudamos a elegir el adecuado.',
    keepData: 'Conservas todos tus embarques y resultados.',
    fastAnswer: 'Respondemos en menos de un día hábil.',
    talkToSales: 'Hablar con ventas',
    later: 'Ahora no',
    mailSubject: 'Plan para {company}',
    mailBody: 'Hola, soy {name} ({email}). Terminé mi prueba gratis y quiero seguir usando SmartLanded.'
  },
  onboarding: {
    title: 'Empieza en 3 pasos',
    subtitle: 'Tu primer costo puesto por SKU en unos minutos.',
    createTitle: 'Crea un embarque',
    createBody: 'Ponle una referencia; lo demás se llena de los documentos.',
    uploadTitle: 'Sube sus documentos',
    uploadBody: 'Factura, packing list, fletes, cuenta de gastos o pedimento: PDF, imagen o XML.',
    reviewTitle: 'Revisa y calcula',
    reviewBody: 'Confirma los renglones sugeridos y obtén el costo unitario por SKU.',
    cta: 'Crear mi primer embarque'
  },
  guide: {
    title: 'Guía de tu embarque',
    progress: '{done} de {total} pasos',
    hide: 'Ocultar guía',
    manual: 'Ver guía completa',
    doneTitle: 'Listo: ya tienes tu costo puesto por SKU',
    doneBody: 'Revisa el desglose y expórtalo a CSV o JSON cuando quieras.',
    doneAction: 'Entendido',
    steps: {
      documents: {
        title: 'Sube los documentos',
        hint: 'Factura comercial, packing list, fletes, cuenta de gastos o pedimento. Se clasifican y se leen solos.',
        action: 'Ir a Documentos'
      },
      items: {
        title: 'Revisa los SKUs',
        hint: 'Salen de la factura comercial. Si no la subiste, súbela o agrega los SKUs a mano.',
        action: 'Ir a SKUs'
      },
      costs: {
        title: 'Confirma los costos',
        hint: 'Los costos salen de tus documentos: confirma, edita o rechaza cada renglón sugerido.',
        action: 'Ir a Costos'
      },
      result: {
        title: 'Calcula',
        hint: 'Todo revisado. Calcula para obtener el costo unitario por SKU.',
        hintErrors: 'El cálculo tiene errores: corrígelos y vuelve a calcular.',
        action: 'Calcular'
      }
    }
  },
  plans: {
    trial: 'Prueba',
    paid: 'Pagado'
  },
  status: {
    draft: 'Borrador',
    review: 'En revisión',
    calculated: 'Calculado',
    closed: 'Cerrado',
    processing: 'Procesando',
    ready: 'Listo',
    failed: 'Falló',
    suggested: 'Sugerido',
    confirmed: 'Confirmado',
    rejected: 'Rechazado',
    duplicate: 'Duplicado'
  },
  layers: {
    merchandise: 'Mercancía',
    origin_logistics: 'Logística en origen',
    international_freight: 'Flete internacional',
    insurance: 'Seguro',
    destination_logistics: 'Logística en destino',
    customs_broker: 'Agente aduanal',
    duties_taxes: 'Impuestos y derechos',
    final_delivery: 'Entrega final',
    other: 'Otros'
  },
  docTypes: {
    commercial_invoice: 'Factura comercial',
    packing_list: 'Lista de empaque',
    freight_invoice: 'Factura de flete',
    forwarder_quote: 'Cotización de forwarder',
    customs_broker_account: 'Cuenta de gastos',
    pedimento: 'Pedimento',
    insurance: 'Seguro',
    other: 'Otro'
  },
  transport: {
    sea_fcl: 'Marítimo FCL',
    sea_lcl: 'Marítimo LCL',
    air: 'Aéreo',
    land: 'Terrestre'
  },
  methods: {
    ai: 'IA',
    cfdi_xml: 'CFDI XML',
    manual: 'Manual'
  },
  modes: {
    actual: 'Real',
    estimate: 'Estimado',
    actualLong: 'Real (pedimento)',
    estimateLong: 'Estimado'
  },
  bases: {
    value: 'valor',
    weight: 'peso',
    volume: 'volumen',
    quantity: 'cantidad',
    duty: 'arancel'
  },
  concepts: {
    PICKUP: 'Recolección / flete terrestre en origen',
    ORIGIN_HANDLING: 'Maniobras en origen / THC',
    EXPORT_CLEARANCE: 'Despacho de exportación',
    VGM: 'VGM / pesaje',
    OCEAN_FREIGHT: 'Flete marítimo',
    AIR_FREIGHT: 'Flete aéreo',
    ROAD_FREIGHT_INTL: 'Flete terrestre internacional',
    BAF: 'Recargo por combustible (BAF/FAF)',
    CAF: 'Ajuste cambiario (CAF)',
    PSS: 'Recargo de temporada alta (PSS)',
    FREIGHT_SURCHARGE: 'Otro recargo de flete',
    INSURANCE: 'Seguro de carga',
    DEST_THC: 'THC en destino / maniobras portuarias',
    DECONSOLIDATION: 'Desconsolidación (LCL)',
    STORAGE: 'Almacenaje',
    DEMURRAGE: 'Demoras',
    DETENTION: 'Uso de contenedor (detention)',
    BL_RELEASE: 'Revalidación / liberación de B/L',
    INSPECTION: 'Reconocimiento / inspección',
    BROKER_FEE: 'Honorarios del agente aduanal',
    BROKER_SERVICES: 'Servicios complementarios del agente',
    IGI: 'Impuesto general de importación (IGI)',
    DTA: 'Derecho de trámite aduanero (DTA)',
    IVA: 'IVA de importación',
    PRV: 'Prevalidación (PRV)',
    IEPS: 'IEPS',
    CC: 'Cuota compensatoria',
    LAST_MILE: 'Entrega al almacén',
    OTHER: 'Otro'
  },
  issues: {
    subject: {
      item: 'SKU "{name}"',
      line: 'Renglón "{name}"',
      vat: 'IVA de "{name}"'
    },
    NO_ITEMS: 'El embarque no tiene SKUs',
    INVALID_AMOUNT: '{subject}: falta el importe o no es un número',
    NO_EXCHANGE_RATE: '{subject}: falta el tipo de cambio {from} → {to}',
    NO_INCOTERM: 'Sin Incoterm válido: no se pueden revisar los costos que cubre el vendedor',
    ALLOCATION_FALLBACK: 'Prorratear por {basis} requiere ese dato en todos los SKUs; se usó el valor',
    ESTIMATE_IGNORES_TAX_LINE: 'El modo estimado calcula los impuestos; se ignoró el renglón "{name}"',
    SELLER_COVERED: '"{name}" es {category}, que el vendedor cubre en {incoterm}: revisa que no se cuente dos veces',
    UNCONFIRMED_LINES_one: '1 renglón de costo sigue como sugerido (sin confirmar)',
    UNCONFIRMED_LINES_other: '{count} renglones de costo siguen como sugeridos (sin confirmar)',
    NO_TAXES: 'No hay impuestos: sube el pedimento o cambia a modo estimado',
    NO_IGI_RATE: 'El SKU "{name}" no tiene tasa de IGI: se asumió 0%',
    PRV_NOT_CONFIGURED: 'La PRV no está configurada en el perfil fiscal: se excluyó del estimado',
    FX_LOOKUP_FAILED: 'Sin tipo de cambio de Banxico para {currency}: {reason}'
  },
  fx: {
    sources: {
      manual: 'capturado a mano',
      pedimento: 'del pedimento',
      banxico: 'Banxico {series}'
    },
    asOf: 'tipo de cambio del {date}',
    errors: {
      FX_NOT_CONFIGURED: 'no está configurado el token de Banxico (BANXICO_TOKEN)',
      FX_UNSUPPORTED_CURRENCY: 'Banxico no tiene una serie configurada para esta moneda',
      FX_UNAVAILABLE: 'Banxico no está disponible en este momento',
      FX_NO_DATA: 'Banxico no tiene tipo de cambio para esa fecha'
    }
  },
  dashboard: {
    title: 'Tablero',
    subtitle: 'Embarques, revisión pendiente y de qué se compone el costo puesto en almacén.',
    shipments: 'Embarques',
    calculated: 'Calculados',
    toReview: 'Renglones por revisar',
    documents: 'Documentos leídos',
    whereTitle: 'A dónde se va el costo puesto en almacén',
    whereSubtitle: 'Participación de cada capa sobre todos los embarques calculados.',
    noneCalculated: 'Todavía no hay embarques calculados.',
    goToShipments: 'Ir a embarques',
    ofLanded: '{value}% del costo puesto en almacén',
    loadFailed: 'No se pudo cargar el tablero'
  },
  adminDashboard: {
    title: 'Tablero de la plataforma',
    subtitle: 'Salud de la plataforma y actividad por cliente.',
    clients: 'Clientes',
    users: 'Usuarios',
    shipments: 'Embarques',
    byClient: 'Por cliente',
    client: 'Cliente',
    calculated: 'Calculados',
    documents: 'Documentos',
    noClients: 'Todavía no hay clientes.'
  },
  clientLifecycle: {
    active: 'Activo',
    terminated: 'Terminado',
    purged: 'Datos eliminados',
    lastActivity: 'Última actividad: {date}',
    noticeSent: 'Aviso de inactividad enviado · se cierra el {date}',
    deletesOn: 'Sus datos se borran el {date}',
    canExport: 'Sus usuarios aún pueden entrar y exportar.',
    purgedOn: 'Eliminados el {date}',
    purgedInactive: 'Prueba cerrada por inactividad · eliminados el {date}',
    terminate: 'Terminar cliente',
    reactivate: 'Reactivar (cancelar borrado)',
    dialogTitle: '¿Terminar a {name}?',
    dialogExport: 'Sus usuarios tendrán {days} días para exportar sus resultados (hasta el {date}).',
    dialogDelete: 'El {date} se borran para siempre sus embarques, documentos y usuarios. No se puede deshacer.',
    dialogUndo: 'Hasta esa fecha puedes reactivarlo y no se pierde nada.',
    dialogKeep: 'Solo conservamos lo que exige la ley: nombre, plan, fechas y la aceptación de los términos.',
    dialogTypeName: 'Para confirmar, escribe el nombre del cliente: {name}',
    dialogConfirm: 'Terminar cliente',
    terminatedToast: '{name} terminado · sus datos se borran el {date}',
    reactivatedToast: '{name} reactivado · se canceló el borrado',
    failed: 'No se pudo actualizar el cliente'
  },
  adminUsers: {
    title: 'Usuarios y clientes',
    subtitle: 'Crea clientes (tenants) y administra sus usuarios.',
    newClient: 'Nuevo cliente',
    clientName: 'Nombre del cliente',
    client: 'Cliente',
    users: 'Usuarios',
    shipments: 'Embarques',
    noClients: 'Todavía no hay clientes.',
    createUser: 'Crear usuario',
    editUser: 'Editar usuario',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo',
    newPassword: 'Nueva contraseña (opcional)',
    password: 'Contraseña (mín. 8)',
    selectClient: 'Selecciona un cliente…',
    active: 'Activo',
    saveChanges: 'Guardar cambios',
    name: 'Nombre',
    role: 'Rol',
    noUsers: 'Todavía no hay usuarios.',
    activate: 'Activar',
    deactivate: 'Desactivar',
    confirmDelete: '¿Eliminar al usuario {email}?',
    loadFailed: 'No se pudieron cargar usuarios/clientes',
    clientCreated: 'Cliente creado',
    clientFailed: 'No se pudo crear el cliente',
    userCreated: 'Usuario creado',
    userUpdated: 'Usuario actualizado',
    userDeleted: 'Usuario eliminado',
    userActivated: 'Usuario activado',
    userDeactivated: 'Usuario desactivado',
    saveFailed: 'No se pudo guardar el usuario',
    deleteFailed: 'No se pudo eliminar el usuario',
    updateFailed: 'No se pudo actualizar el usuario',
    plan: 'Plan',
    shipmentLimit: 'Límite de embarques',
    unlimited: 'Sin límite',
    usageOf: '{used} de {limit} embarques',
    usageUnlimited: '{used} embarques · sin límite',
    selfSignup: 'Registro propio',
    planUpdated: 'Plan actualizado',
    planFailed: 'No se pudo actualizar el plan'
  },
  shipments: {
    title: 'Embarques',
    subtitle: 'Cada embarque agrupa sus documentos; la IA los lee y el motor calcula el costo por SKU.',
    new: 'Nuevo embarque',
    create: 'Crear embarque',
    creating: 'Creando…',
    created: 'Embarque creado',
    createFailed: 'No se pudo crear el embarque',
    loadFailed: 'No se pudieron cargar los embarques',
    reference: 'Referencia',
    referencePlaceholder: 'p. ej. OC-4512 / BL MSCU1234567',
    incoterm: 'Incoterm',
    fromInvoice: 'De la factura',
    transport: 'Transporte',
    mode: 'Modo',
    usdRate: 'USD → MXN',
    usdRatePlaceholder: 'Del pedimento',
    search: 'Buscar referencia',
    docs: 'Docs',
    skus: 'SKUs',
    toReview: 'Por revisar',
    landedCost: 'Costo puesto en almacén',
    empty: 'Todavía no hay embarques.',
    confirmDelete: '¿Eliminar el embarque {reference}?',
    deleted: 'Embarque eliminado',
    deleteFailed: 'No se pudo eliminar'
  },
  shipment: {
    back: '← Embarques',
    notFound: 'Embarque no encontrado.',
    loadFailed: 'No se pudo cargar el embarque',
    noIncoterm: 'Sin Incoterm',
    noTransport: 'Transporte —',
    settings: 'Configuración',
    hideSettings: 'Ocultar configuración',
    exportCsv: 'Exportar CSV',
    exportJson: 'Exportar JSON',
    exportFailed: 'No se pudo exportar',
    calculate: 'Calcular',
    recalculate: 'Recalcular',
    calculating: 'Calculando…',
    calculated: 'Costo puesto en almacén calculado',
    calculatedWithErrors: 'Se calculó con errores — revisa la pestaña Resultado',
    calculateFailed: 'Falló el cálculo',
    pending_one: '1 renglón de costo sugerido por la extracción espera revisión.',
    pending_other: '{count} renglones de costo sugeridos por la extracción esperan revisión.',
    reviewCosts: 'Revisar costos',
    stale: 'Los datos cambiaron desde el último cálculo — recalcula para actualizar el resultado.',
    tabs: {
      documents: 'Documentos',
      items: 'SKUs',
      costs: 'Costos',
      result: 'Resultado'
    }
  },
  settings: {
    reference: 'Referencia',
    incoterm: 'Incoterm',
    transport: 'Transporte',
    mode: 'Modo',
    reportCurrency: 'Moneda de reporte',
    vatRecoverable: 'El importador acredita el IVA (se reporta aparte, no como costo)',
    ratesTitle: 'Tipos de cambio → {currency}',
    ratesHelp: 'Se usan cuando un renglón o SKU no trae su propio tipo de cambio. El pedimento llena el USD; los que falten se traen de Banxico. Los que captures aquí nunca se reemplazan.',
    addRate: '+ Agregar tipo de cambio',
    rateDate: 'Fecha del tipo de cambio',
    rateDateHelp: 'Fecha de entrada o de pago. Vacío = hoy.',
    refresh: 'Actualizar de Banxico',
    refreshing: 'Actualizando…',
    refreshed_one: '1 tipo de cambio actualizado de Banxico',
    refreshed_other: '{count} tipos de cambio actualizados de Banxico',
    refreshNothing: 'Nada que actualizar: los tipos de cambio son capturados a mano o del pedimento',
    refreshFailed: '{currency}: {reason}',
    allocationTitle: 'Prorrateo por capa',
    allocationHelp: 'Cómo se reparte cada capa entre los SKUs. Predeterminado: el catálogo de conceptos.',
    save: 'Guardar configuración',
    saved: 'Configuración guardada',
    saveFailed: 'No se pudo guardar'
  },
  documents: {
    pickFiles: 'Primero elige uno o más archivos',
    upload: 'Subir y extraer',
    uploading: 'Leyendo documentos…',
    uploadHelp: 'Factura comercial, lista de empaque, facturas de flete, cuenta de gastos, pedimento, póliza de seguro. PDF o foto se leen con IA; un CFDI en XML se lee directo, sin IA.',
    processed_one: '1 documento procesado',
    processed_other: '{count} documentos procesados',
    failedCount_one: 'Falló la extracción de 1 documento',
    failedCount_other: 'Falló la extracción de {count} documentos',
    uploadFailed: 'No se pudo subir',
    confirmDelete: '¿Eliminar {file}? También se eliminan los SKUs y renglones de costo que generó.',
    deleted: 'Documento eliminado',
    deleteFailed: 'No se pudo eliminar',
    file: 'Archivo',
    type: 'Tipo',
    method: 'Método',
    confidence: 'Confianza',
    uploaded: 'Subido',
    unclassified: 'Sin clasificar',
    empty: 'Todavía no hay documentos.'
  },
  items: {
    help: 'Los SKUs salen de la factura comercial; la lista de empaque completa peso y volumen. El IGI % sólo se usa en modo estimado.',
    missingBasis: 'Algunos SKUs no tienen peso o volumen: los renglones que se prorratean por esos datos usarán el valor.',
    needsIgi: 'Modo estimado: los SKUs sin IGI % se estiman con 0%.',
    empty: 'Todavía no hay SKUs — sube la factura comercial o agrégalos a mano.',
    add: '+ Agregar SKU',
    saveFailed: 'No se pudo guardar el SKU',
    confirmDelete: '¿Eliminar el SKU {name}?',
    deleteFailed: 'No se pudo eliminar',
    columns: {
      sku: 'SKU',
      description: 'Descripción',
      quantity: 'Cant.',
      amount: 'Importe',
      currency: 'Mon.',
      tariffFraction: 'Fracción',
      igiRate: 'IGI %',
      grossWeightKg: 'Kg',
      volumeCbm: 'm³'
    }
  },
  costs: {
    help: 'Renglones propuestos por la extracción. Confirma, corrige o rechaza; los duplicados (p. ej. impuestos que la cuenta de gastos vuelve a cobrar) no se suman.',
    confirmAll: 'Confirmar todos ({count})',
    add: 'Agregar renglón',
    confirmed: 'Renglones confirmados',
    saved: 'Renglón guardado',
    amountRequired: 'El importe y la moneda son obligatorios',
    empty: 'Todavía no hay renglones de costo.',
    concept: 'Concepto',
    source: 'Origen',
    amount: 'Importe',
    vat: 'IVA',
    flags: 'Marcas',
    conf: 'Conf.',
    manual: 'Manual',
    unrecognised: 'Concepto no reconocido',
    paidOnBehalf: 'pagado por cuenta del cliente',
    duplicateOf: 'duplicado de "{name}" ({source})',
    flagCustomsValue: 'valor en aduana',
    flagRecoverable: 'acreditable',
    flagBy: 'por {basis}',
    confirm: 'Confirmar',
    keep: 'Conservar',
    reject: 'Rechazar',
    confirmDelete: '¿Eliminar este renglón de costo?',
    form: {
      concept: 'Concepto',
      freeText: '— texto libre —',
      layer: 'Capa',
      description: 'Descripción',
      amount: 'Importe (antes de IVA)',
      currency: 'Moneda',
      exchangeRate: 'Tipo de cambio',
      exchangeRatePlaceholder: 'del embarque',
      vat: 'IVA',
      spreadBy: 'Prorratear por',
      inCustomsValue: 'Suma al valor en aduana',
      recoverable: 'IVA acreditable'
    }
  },
  result: {
    notCalculated: 'Todavía no se calcula — revisa los costos y presiona Calcular.',
    errors: 'Errores — el resultado está incompleto',
    warnings: 'Advertencias',
    landedCost: 'Costo puesto en almacén',
    calculatedAt: 'Calculado {date} · {mode}',
    overMerchandise: 'Sobre la mercancía',
    overMerchandiseHint: 'Logística, agente e impuestos encima del valor de la mercancía',
    customsValue: 'Valor en aduana',
    customsValueHint: 'Mercancía + incrementables',
    recoverableVat: 'IVA acreditable',
    recoverableVatHint: 'Flujo de efectivo, no costo',
    chartTitle: 'Costo unitario por SKU y capa ({currency})',
    chartSubtitle: 'Cada barra es una unidad del SKU, dividida en lo que la compone.',
    sku: 'SKU',
    qty: 'Cant.',
    total: 'Total',
    unitCost: 'Costo unitario',
    taxesEstimated: 'Impuestos y derechos (estimados)',
    taxesActual: 'Impuestos y derechos (del pedimento)',
    ratesUsed: 'Tipos de cambio usados',
    comparison: {
      title: 'Estimado vs real',
      subtitle: 'Lo que habría dicho el estimado (perfil fiscal + tarifa) contra el pedimento. Positivo = el costo real fue mayor.',
      concept: 'Concepto',
      estimate: 'Estimado',
      actual: 'Real',
      diff: 'Diferencia',
      landedCost: 'Costo puesto en almacén',
      unitCostTitle: 'Costo unitario por SKU',
      estimateWarnings: 'El estimado tuvo advertencias:'
    }
  },
  tariffs: {
    title: 'Tarifas (IGI)',
    subtitle: 'Tasa general de IGI por fracción arancelaria. Los SKUs con fracción y sin IGI % la toman de aquí.',
    importTitle: 'Importar CSV',
    importHelp: 'Exporta la tarifa (SNICE / LIGIE) a CSV con un encabezado que nombre las columnas de fracción, descripción y tasa. Tasas en porcentaje: 10, 10%, Ex. Las fracciones existentes se actualizan.',
    import: 'Importar',
    importing: 'Importando…',
    imported: '{count} tasas importadas',
    importErrors_one: '1 renglón omitido',
    importErrors_other: '{count} renglones omitidos',
    importFailed: 'No se pudo importar el archivo',
    pickFile: 'Primero elige un archivo CSV',
    search: 'Buscar fracción o descripción',
    fraction: 'Fracción',
    description: 'Descripción',
    rate: 'IGI',
    source: 'Origen',
    updated: 'Actualizado',
    empty: 'Todavía no hay tasas — importa un CSV.',
    confirmDelete: '¿Eliminar la tasa de {fraction}?',
    deleted: 'Tasa eliminada',
    deleteFailed: 'No se pudo eliminar',
    loadFailed: 'No se pudieron cargar las tarifas'
  },
  document: {
    back: '← Embarque',
    notFound: 'Documento no encontrado.',
    loadFailed: 'No se pudo cargar el documento',
    unclassified: 'Sin clasificar',
    extractionConfidence: 'confianza de extracción {value}',
    typePlaceholder: '— Tipo de documento —',
    reextract: 'Volver a extraer',
    working: 'Procesando…',
    loadingFile: 'Cargando archivo…',
    noPreview: 'No hay vista previa para {type}.',
    download: 'Descargar',
    extracted: 'Datos extraídos',
    fromTemplate: 'Empezar con plantilla',
    emptyWithType: 'No se extrajeron datos. Empieza con la plantilla o pega un JSON.',
    emptyNoType: 'Primero elige el tipo de documento.',
    saveHelp: 'Guardar vuelve a generar los SKUs o renglones de costo de este documento.',
    invalidJson: 'JSON inválido: {error}',
    saved: 'Guardado — SKUs y renglones de costo regenerados',
    saveFailed: 'No se pudo guardar',
    extracted_ok: 'Extracción terminada',
    extractFailed: 'Falló la extracción'
  }
}

export default esMX
